import React from 'react'
import { RegisterSuccessWrapper } from './RegisterSuccessStyled'
import { Button, Col, Row } from 'antd'
import { CenterDiv, FinalStepContent, FinalStepTitle } from '../../components/CommonStyled/CommonStyled'
import IMAGES from '../../images'
import moment from 'moment/moment'
import {
  CloseIcon,
  FormBody,
  FormHeader,
  RegisterFormWrapper,
  RegisterTitle,
} from '../../components/RegisterForm/RegisterFormStyled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { PAGES, VIEW_MODE } from '../../constant'
import { useNavigate } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import { pageStatusState } from '../../recoil/landingPageState'
import Maintain from '../../components/Maintain/Maintain'

const RegisterSuccess = () => {
  const pageStatus = useRecoilValue(pageStatusState)
  const navigate = useNavigate()

  const goHome = () => {
    navigate(PAGES.HOME.PATH)
  }

  return (
    pageStatus.status === 'ON' ?
      <RegisterSuccessWrapper>
        <RegisterFormWrapper>
          <FormHeader>
            <img src={IMAGES.WHITE_LOGO} className={'register-logo'} />
          </FormHeader>
          <FormBody>
            <RegisterTitle>
              <span>THÔNG TIN ĐĂNG KÝ</span>
              <CloseIcon onClick={goHome}>
                <FontAwesomeIcon color={'#E10600'} size={'2x'} icon={faTimes} />
              </CloseIcon>
            </RegisterTitle>
            <Row justify={'center'}>
              <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                <CenterDiv>
                  <img src={IMAGES.SUCCESS_REGISTER} alt={'SUCCESS_REGISTER'} />
                </CenterDiv>
                <FinalStepTitle textAlign={'center'}>Gửi đăng ký thành công!</FinalStepTitle>
                <FinalStepContent>
                  Cảm ơn Quý Khách đã quan tâm đến Sản phẩm/Dịch vụ của Dự án. Chúng tôi sẽ sớm liên hệ để tư vấn chi
                  tiết!
                </FinalStepContent>
              </Col>
            </Row>
            <Row justify={'center'}>
              <Col xxl={8} xl={8} lg={16} md={16} sm={24} xs={24}>
                <Button className={'gradient-btn'} type={'primary'} htmlType={'button'} onClick={goHome} block>
                  Về trang chủ
                </Button>
              </Col>
            </Row>
          </FormBody>
        </RegisterFormWrapper>
      </RegisterSuccessWrapper>
      : pageStatus.status === 'OFF'
        ? <Maintain />
        : <></>
  )
}

export default RegisterSuccess
